// extracted by mini-css-extract-plugin
export default {"previewEmailButtonWrapper":"OxVUkX4pxuBo8O8W0wGe"};